<template>
  <div class="unit-container">
    <div class="unit-column">
      <div class="unit-title">Pressure</div>
      <div class="unit-option" v-for="n, index in this.pressureOptions()" :key="index">
        <input class="unit-radio" type="radio" v-model="this.pressureUnit" :id="'u-pressure-option-' + n" name="pressure" :value="n">
        <label class="unit-label" :for="n + 'pressure'">{{ n }}</label>
      </div>
    </div>
    <div class="unit-column">
      <div class="unit-title">Total Flow</div>
      <div class="unit-option" v-for="n, index in this.flowOptions()" :key="index">
        <input class="unit-radio" type="radio" v-model="this.flowUnit" :id="'u-flow-option-' + n" name="flow" :value="n">
        <label class="unit-label" :for="n + 'flow'">{{ n }}</label>
      </div>
    </div>
    <div class="unit-column">
      <div class="unit-title">Emitter Flow</div>
      <div class="unit-option" v-for="n, index in this.emitterFlowOptions()" :key="index">
        <input class="unit-radio" type="radio" v-model="this.emitterFlowUnit" :id="'u-emitterFlow-option-' + n" name="emitterFlow" :value="n">
        <label class="unit-label" :for="n + 'emitterFlow'">{{ n }}</label>
      </div>
    </div>
    <div class="unit-column">
      <div class="unit-title">Length</div>
      <div class="unit-option" v-for="n, index in this.lengthOptions()" :key="index">
        <input class="unit-radio" type="radio" v-model="this.lengthUnit" :id="'u-length-option-' + n" name="length" :value="n">
        <label class="unit-label" :for="n + 'length'">{{ n }}</label>
      </div>
    </div>
    <div class="unit-column">
      <div class="unit-title">Velocity</div>
      <div class="unit-option" v-for="n, index in this.velocityOptions()" :key="index"  >
        <input class="unit-radio" type="radio" v-model="this.velocityUnit" :id="'u-velocity-option-' + n" name="velocity" :value="n">
        <label class="unit-label" :for="n + 'velocity'">{{ n }}</label>
      </div>
    </div>
    <div class="unit-column">
      <div class="unit-title">Slope</div>
      <div class="unit-option" v-for="n, index in this.slopeOptions()" :key="index">
        <input v-if="n === this.lengthUnit || index === 0" class="unit-radio" type="radio" v-model="this.slopeUnit" :id="'u-slope-option-' + n" name="slope" :value="n">
        <label v-if="n === this.lengthUnit || index === 0" class="unit-label" :for="n + 'slope'">{{ n }}</label>
      </div>
    </div>
    <div class="unit-column">
      <div class="unit-title">Time</div>
      <div class="unit-option" v-for="n, index in this.timeOptions()" :key="index">
        <input class="unit-radio" type="radio" v-model="this.timeUnit" :id="'u-time-option-' + n" name="time" :value="n">
        <label class="unit-label" :for="n + 'time'">{{ n }}</label>
      </div>
    </div>
    <div class="unit-column">
      <div class="unit-title">Pipe Diameter</div>
        <div class="unit-option" v-for="n, index in this.diameterOptions()" :key="index">
          <input class="unit-radio" type="radio" v-model="this.diameterUnit" :id="'u-diameter-option-' + n" name="diameter" :value="n">
          <label class="unit-label" :for="n + 'diameter'">{{ n }}</label>
        </div>
    </div>
  </div>
</template>

<script>
import { useSettingsStore } from '../../store/SettingsStore';

export default {
  computed: {
    lengthUnit: {
      get () {
        return useSettingsStore().getLengthUnit;
      },
      set (value) {
        useSettingsStore().setLengthUnit(value);
      },
    },
    pressureUnit: {
      get () {
        return useSettingsStore().getPressureUnit;
      },
      set (value) {
        useSettingsStore().setPressureUnit(value);
      },
    },
    flowUnit: {
      get () {
        return useSettingsStore().getFlowUnit;
      },
      set (value) {
        useSettingsStore().setFlowUnit(value);
      },
    },
    emitterFlowUnit: {
      get () {
        return useSettingsStore().getEmitterFlowUnit;
      },
      set (value) {
        useSettingsStore().setEmitterFlowUnit(value);
      },
    },
    velocityUnit: {
      get () {
        return useSettingsStore().getVelocityUnit;
      },
      set (value) {
        useSettingsStore().setVelocityUnit(value);
      },
    },
    slopeUnit: {
      get () {
        return useSettingsStore().getSlopeUnit;
      },
      set (value) {
        useSettingsStore().setSlopeUnit(value);
      },
    },
    timeUnit: {
      get () {
        return useSettingsStore().getTimeUnit;
      },
      set (value) {
        useSettingsStore().setTimeUnit(value);
      },
    },
    diameterUnit: {
      get () {
        return useSettingsStore().getDiameterUnit;
      },
      set (value) {
        useSettingsStore().setDiameterUnit(value);
      },
    },
  },
  methods: {
    lengthOptions () {
      return useSettingsStore().lengthOptions;
    },
    pressureOptions () {
      return useSettingsStore().pressureOptions;
    },
    flowOptions () {
      return useSettingsStore().flowOptions;
    },
    emitterFlowOptions () {
      return useSettingsStore().emitterFlowOptions;
    },
    velocityOptions () {
      return useSettingsStore().velocityOptions;
    },
    slopeOptions () {
      return useSettingsStore().slopeOptions;
    },
    timeOptions () {
      return useSettingsStore().timeOptions;
    },
    diameterOptions () {
      return useSettingsStore().diameterOptions;
    },
  }
};
</script>

<style scoped>
.unit-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1rem;
  width: 100%;
}
.unit-title {
  height: 40px;
  color: black;
  font-weight: 700;
  text-align: center;
  border-bottom: 4px lightgray solid;
}
.unit-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #444444;
}
.unit-radio, .unit-label {
  user-select: none;
  cursor: pointer;
}
.comp {
  width: 15px;
  height: 15px;
  margin: 1px 5px;
  border: 1px blue solid;
  border-radius: 50%;
}
input[type='radio']:checked::before {
  display: block;
  background-color: red;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
